import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';

export default function Popularclass() {
    const classes = [
        // {
        //     image: "images/merin.webp",
        //     date: "1 Days",
        //     title: "1 Day Workshop",
        //     path:'/courses'

        // },
        // {
        //     image: "images/entre.webp",
        //     date: "3 Days",
        //     title: "Short Term Course",
        //     path:'/courses'

        // },
        {
            image: "images/upcook.jpg",
            // date: "(5 Days)",
            title: "Customized Module",
            path: '/customized-module'

        },
        {
            image: "images/bakfou.jpg",
            date: "(5 Days)",
            title: "Bakery Foundation Course",
            path: '/bakeryfoundationcourse'

        },

        {
            image: "images/bakery.jpg",
            // date: "(1 Month)",
            title: "Professional Course",
            path: '/professional-bakery'

        },

        {
            image: "images/basicad.jpg",
            date: "(1 Month)",
            title: "Basic to Intermediate Courses",
            path: '/basic-to-intermediate-course'

        },
        {
            image: "images/profess.jpg",
            date: "(2 Months)",
            title: "Diploma Course",
            path: '/diploma'

        },
        {
            image: "images/short.jpg",
            // date: "2 Months",
            title: "Short Term Course",
            path: '/courses'

        },
        {
            image: "images/one.jpg",
            // date: "(2 Months)",
            title: "One Day Programs",
            path: '/onecourse'

        },

    ];

    const courses = [
        {
            title: (
                <>
                    5 Days Hands-on Workshop <br />
                    Bakery Foundation Program
                </>
            ),

            newPrice: '18,000',
            image: 'images/upcook.jpg',
            href: '/bakeryfoundationcourse',
        },
        {
            title: (
                <>
                    1 Day Hands-on Workshop <br />
                    Eggless Bake Workshop
                </>
            ),

            newPrice: '4,000',
            image: 'images/merin.webp',
            href: '/egglessbake',
        },
        {
            title: (
                <>
                    1 Day Hands-on Workshop <br />
                    All about Cheesecake
                </>
            ),

            newPrice: '4,000',
            image: 'images/cheese.webp',
            href: '/cheesecake',
        },

        {
            title: (
                <>
                    1 Day Hands-on Workshop <br />
                    Choux Pastry Workshop
                </>
            ),

            newPrice: '3,500',
            image: 'images/cahoux.jpg',
            href: '/chouxpastry'
        },
        {
            title: (
                <>
                    1 Day Hands-on Workshop <br />
                    Brownie Workshop
                </>
            ),
            // oldPrice: '34,999',
            newPrice: '4,000',
            image: 'images/brownie.jpg',
            href: '/brownie'
        },
        {
            title: (
                <>
                    1 Day Hands-on Workshop <br />
                    Cookies Workshop
                </>
            ),
            // oldPrice: '34,999',
            newPrice: '4,000',
            image: 'images/cookie.webp',
            href: '/cookies'
        }
    ];

    const navigate = useNavigate(); // Initialize the useNavigate hook

    // Function to navigate to the About Us page
    const navigateToCourses = (path) => {
        navigate(path); // Adjust the path based on your routing structure
    };
    return (
        <>
            <div className="class-head" id="course">
                <div className="cooking-head">
                    <h1>Courses by Duration</h1>
                    {/* <img src="images/knife.webp" alt="Knife" /> */}
                </div>
                <div className="pop-class">
                    <Container>
                        <Row style={{ marginBottom: '0%' }}>
                            {classes.map((cls, index) => (

                                <Col md={4} key={index} style={{ marginBottom: '5%' }}>
                                    <Card className="cookie" style={{ border: 'none' }} onClick={() => navigateToCourses(cls.path)}>
                                        <Card.Body>
                                            <div className="image">
                                                <Card.Img src={cls.image} alt="courses_types" className="fixed-height-img" loading="lazy" />
                                                <div className="cls-text">
                                                    <Card.Text>
                                                        {/* <p className="cls-date">
                                                            <i className="fa fa-clock" style={{ color: "#e65c8c" }}></i>&nbsp;
                                                            {cls.date}
                                                        </p> */}
                                                    </Card.Text>
                                                    <Card.Title>
                                                        <h5>{cls.date} {cls.title}</h5>
                                                    </Card.Title>
                                                    {/* <Card.Text>
                                                            <p className="cls-para">{cls.description}</p>
                                                            <h6>LEARN MORE</h6>
                                                        </Card.Text> */}
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))
                            }
                        </Row>
                    </Container>
                </div>
                {/* <button className="centered-button" onClick={()=>navigate('/courses')}>Workshops</button> */}
            </div>
            {/* <div className="upcoming_course class-head" id="upcoming">
                <div className="Upcoming-head">
                    <h1 className="text-center">Upcoming Courses</h1>
                    <img src="images/knife.webp" alt="Knife" />
                </div>
                <Swiper
                    modules={[Navigation, Pagination]}
                    navigation
                    pagination={{ clickable: true }}
                    spaceBetween={20}
                    breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}

                >
                    {courses.map((course, index) => (
                        <SwiperSlide key={index}>

                            <div className="course-card mb-5">
                                <Link to={course.href} style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <div className="img-wrapper">
                                        <img src={course.image} alt={course.title} />
                                        <span className="sale-badge">Sale</span>
                                    </div>
                                    <p className="course-title">{course.title}</p>
                                    <p className="course-price">

                                        Rs. {course.newPrice}
                                    </p>
                                </Link>
                            </div>

                        </SwiperSlide>
                    ))}
                </Swiper>

            </div> */}


        </>
    );
}
